import {
  WithNativeHTMLProps,
} from "@kalyzee/kast-web-sdk/web-components";
import { Meeting, MeetingState } from "@kalyzee/kast-web-sdk/websocket";
import React, { useRef } from "react";
import { formatTimer, OverlayContainer, VideoPauseOverlay } from "@kalyzee/kalyzee-ui";
import { MainClockRenderer } from "../../contexts/clock/renderer";

export interface PauseViewProps extends WithNativeHTMLProps<HTMLDivElement> {
  meeting?: Meeting;
  onResume?: () => void;
  hide?: boolean;
  className?: string;
  style?: React.CSSProperties;
  isExpert?: boolean;
  enabled?: boolean;
  children: React.ReactNode;
}

const PauseView = ({ 
  meeting, 
  onResume, 
  hide = false,
  enabled, 
  children,
}: PauseViewProps) => {
  const defaultDateRef = useRef<Date>(new Date());
  // ---------------------------------------------------------------------- //
  // ---------------------------  RENDER ----------------------------- //
  // ---------------------------------------------------------------------- //

  if (hide) return <>{children}</>;

  const paused = meeting?.state === MeetingState.PAUSED;
  if (!paused) return <>{children}</>;

  const pausedAt = meeting?.pausedAt ? new Date(meeting.pausedAt) : defaultDateRef.current;

  const timerNode = (
    <MainClockRenderer
      render={_ => formatTimer(pausedAt)}
    />
  );

  return (
    <OverlayContainer
      nativeProps={{
        onClick: () => enabled && onResume?.(),
      }}
      style={{
        cursor: enabled ? "pointer" : "default",
      }}
      overlay={
        <VideoPauseOverlay
          timerNode={timerNode}
          onResume={enabled ? () => {} : undefined} // Just to show hover animation
        />
      }
    >
      {children}
    </OverlayContainer>
  );

};

export default PauseView;
